import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from 'app/services/app.service';
import {SakuraModelService} from 'app/core/sakuraModel.service';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import {UserModelService} from 'app/models/user-model.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Platform} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class OtherModelService extends SakuraModelService {

  urlJiraBugReport = 'https://jira-bug.sakura.staging.lobsterlab.io/report';

  userModelService: UserModelService;
  private platform: Platform;

  constructor(
    http: HttpClient,
    appService: AppService,
    userModelService: UserModelService,
    platform: Platform,
    private deviceService: DeviceDetectorService,
  ) {
    super(http, appService);

    this.userModelService = userModelService;
    this.platform = platform;
  }

  getBugReportForm() {
    return (callback: (response: ApiResponse) => void) => {
        this.getRequest({}, (answer: ApiResponse) => {
          callback(answer);
        }, this.urlJiraBugReport, false);
    };
  }

  saveBugReportForm() {
    return (id: number, values: any, callback: (response: ApiResponse) => void) => {
      const postData = values;

      // const osVersion = this.deviceService.getDeviceInfo().os +
      //   (this.deviceService.getDeviceInfo().os_version === 'unknown' ? '' : (' ' + this.deviceService.getDeviceInfo().os_version));

      // const osVersion = this.deviceService.getDeviceInfo().os;

      const deviceStr = navigator.userAgent.substring(navigator.userAgent.indexOf('(') + 1, navigator.userAgent.indexOf(')'));

      postData.data = {
        userId:         this.userModelService.user.id,
        domain:         window.location.href,
        // device:         this.deviceService.getDeviceInfo().device,
        device:         deviceStr,
        browser:        this.deviceService.getDeviceInfo().browser,
        browserVersion: this.deviceService.getDeviceInfo().browser_version,
        screenWIdth:    this.platform.width(),
        screenHeight:   this.platform.height()
      };

      console.log('saveBugReportForm postData', postData);
      // console.log(this.deviceService.getDeviceInfo());
      // console.log(this.userModelService);

      // console.log(values);
      // console.log(id);
      // console.log(callback);

      this.postRequest(postData,{}, (answer: ApiResponse) => {
        callback(answer);
      }, this.urlJiraBugReport, false);
    };
  }
}
